export enum WebsocketCommands {
  Authentication = 'Authentication',
  Authenticated = 'Authenticated',
  Logout = 'Logout',
}
